var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout_168"}},[_c('div',{staticStyle:{"min-height":"100vh"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }